import React from 'react';
export function Eyebrow({
  children,
  danger = false
}: {
  children: React.ReactNode;
  danger?: boolean;
}) {
  return <p className={`mb-3 text-center text-[11px] font-extrabold uppercase tracking-[.16em] md:text-sm ${danger ? 'text-red-500' : 'text-accent-dark'}`} data-id="element-302" data-mp="2i6ntz6tte4yu">
      {children}
    </p>;
}
export function SectionTitle({
  children
}: {
  children: React.ReactNode;
}) {
  return <h2 className="mx-auto max-w-3xl text-center text-2xl font-black uppercase leading-tight text-ink md:text-4xl" data-id="element-303" data-mp="35u5p9ccafl6k">
      {children}
    </h2>;
}
export function SectionLead({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="mx-auto mt-3 max-w-2xl text-center text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-304" data-mp="3euu5mdp5lxmm">
      {children}
    </p>;
}